import { create } from 'zustand'

import { Setters, State } from './types'
import { initialState } from './state'
import { ESearchLevel } from '../../../../types-library/src'

export const usePolygonStore = create<State & Setters>((set) => ({
  ...initialState,

  setIsEnabledHeatMap: (isEnabledHeatMap: boolean) =>
    set(() => ({ isEnabledHeatMap })),
  setPolygonTiles: (polygonTiles) => set(() => ({ polygonTiles })),
  setPolygonNavigation: (params) => {
    set((state) => ({
      polygonNavigation: {
        ...state.polygonNavigation,
        [params.level]: params?.properties,
      },
    }))
  },
  clearPolygonNavigation: (params) => {
    set((state) => ({
      polygonNavigation: {
        ...state.polygonNavigation,
        [ESearchLevel.STATE]: params.state
          ? undefined
          : state.polygonNavigation[ESearchLevel.STATE],
        [ESearchLevel.MUNICIPALITY]: params.municipality
          ? undefined
          : state.polygonNavigation[ESearchLevel.MUNICIPALITY],
        [ESearchLevel.NEIGHBORHOOD]: params.neighborhood
          ? undefined
          : state.polygonNavigation[ESearchLevel.NEIGHBORHOOD],
      },
    }))
  },
  setHeatMapCategory: (category) => set(() => ({ heatMapCategory: category })),
  setIsHoveredHeatMapCategorySelector: (isHovered) =>
    set(() => ({ isHoveredHeatMapCategorySelector: isHovered })),
}))
